import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { AccountsService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private themeKey = 'active-theme';  // Local storage key

  constructor(
    rendererFactory: RendererFactory2,
    private readonly accountService: AccountsService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  // Get the saved theme from local storage
  getSavedTheme(): { primary: string; accent: string } {
    const bgColor: string = this.accountService.getBackColor();
    const textColor: string = this.accountService.getForeColor();
    return { primary:bgColor, accent:textColor};
    // const theme = localStorage.getItem(this.themeKey);
    // return theme ? JSON.parse(theme) : { primary: '#3f51b5', accent: '#ff4081' }; // Default colors
  }

  // Apply theme dynamically
  applyTheme(primary: string, accent: string): void {
    const bgColor =this.accountService.getBackColor();
    const textColor=this.accountService.getForeColor();
    document.documentElement.style.setProperty('--primary-color', bgColor);
    document.documentElement.style.setProperty('--accent-color', textColor);
    document.documentElement.style.setProperty('--mat-primary-color', bgColor);
    document.documentElement.style.setProperty('--mdc-slider-handle-color', bgColor);
    document.documentElement.style.setProperty('--mat-icon-color', bgColor);
    document.documentElement.style.setProperty('--mat-badge-background-color', bgColor);
    document.documentElement.style.setProperty('--mat-badge-text-color', textColor);
    document.documentElement.style.setProperty('--mdc-fab-small-container-color',bgColor);
    document.documentElement.style.setProperty('--mat-fab-small-foreground-color', textColor);
    document.documentElement.style.setProperty('--mat-switch-label-text-color', bgColor);
    document.documentElement.style.setProperty('--mdc-tab-indicator-active-indicator-color', bgColor);
    document.documentElement.style.setProperty('--mat-expansion-header-text-color', bgColor);
    document.documentElement.style.setProperty('--mat-minimal-pseudo-checkbox-selected-checkmark-color', bgColor);
    document.documentElement.style.setProperty('--mat-checkbox-label-text-color', bgColor);
    document.documentElement.style.setProperty('--mdc-checkbox-selected-icon-color', bgColor);
    document.documentElement.style.setProperty('--mdc-switch-selected-handle-color', bgColor);
    document.documentElement.style.setProperty('--mdc-filled-text-field-input-text-placeholder-color', bgColor);
    document.documentElement.style.setProperty('--mdc-outlined-text-field-caret-color', bgColor);
    // Save to local storage
    localStorage.setItem(this.themeKey, JSON.stringify({ primary, accent }));
  }

  // Load the saved theme on app initialization
  loadSavedTheme(): void {
    this.applyTheme(this.accountService.getBackColor(), this.accountService.getForeColor());
  }
}
